/**
 * Service for handling enquiry submissions
 */

/**
 * Submits an enquiry to the Londolozi CMS API
 * 
 * @param {Object} formData - The form data
 * @param {string} type - The type of enquiry (general-enquiry, retreat-enquiry, agent-enquiry)
 * @returns {Promise} - The API response
 */
export async function submitEnquiry(formData, type = 'general-enquiry') {
  try {
    const { email, firstName, lastName, ...otherFields } = formData;
    
    const payload = {
      type,
      to: email,
      toName: `${firstName} ${lastName}`,
      emailData: {
        email,
        first_name: firstName,
        last_name: lastName,
        ...otherFields
      }
    };

    const response = await fetch('https://cms.londolozi.com/wp-json/londolozi-cms/v1/saveAndSendEnquiry', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to submit enquiry');
    }

    return data;
  } catch (error) {
    console.error('Error submitting enquiry:', error);
    throw error;
  }
}

/**
 * Determine the enquiry type based on the form context
 * 
 * @param {string} contactStateScope - The scope of the contact state
 * @param {Object} formData - The form data
 * @returns {string} - The enquiry type
 */
export function determineEnquiryType(contactStateScope, formData) {
  if (contactStateScope === 'retreat') {
    return 'retreat-enquiry';
  } else if (contactStateScope === 'agent') {
    return 'agent-enquiry';
  } else {
    return 'general-enquiry';
  }
}
